import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOneClubMastercardFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 224 80"
    {...props}
  >
    <style>{'.st3{fill:#fff}'}</style>
    <g>
      <path
        id="Rectangle-path"
        d="M164.7 17.2h25V62h-25z"
        style={{
          fill: '#f16022',
        }}
      />
      <path
        id="XMLID_107_"
        d="M166.2 39.6c0-9.1 4.3-17.2 10.9-22.4-4.9-3.8-11-6.1-17.6-6.1-15.7 0-28.5 12.8-28.5 28.5s12.8 28.5 28.5 28.5c6.7 0 12.8-2.3 17.6-6.1-6.6-5.2-10.9-13.3-10.9-22.4"
        style={{
          fill: '#e91d25',
        }}
      />
      <path
        id="Shape"
        d="M223.3 39.6c0 15.7-12.8 28.5-28.5 28.5-6.7 0-12.8-2.3-17.6-6.1 6.6-5.2 10.9-13.3 10.9-22.4s-4.3-17.2-10.9-22.4c4.9-3.8 11-6.1 17.6-6.1 15.7 0 28.5 12.8 28.5 28.5m-2.7 17.7v-.9h.4v-.2h-1v.2h.4v.9zm1.8 0v-1.1h-.3l-.3.8-.3-.8h-.3v1.1h.2v-.8l.3.7h.2l.3-.7v.8z"
        style={{
          fill: '#f69e1e',
        }}
      />
    </g>
    <path
      d="M33.9 26.5c.1-4.9-2.3-9.7-6.1-12.8v25.6c3.9-3.2 6.2-8 6.1-12.8M6.7 14.3l4.6 4 3.9-2.4V37C7.9 35.5 4.5 27 8.9 20.8l-4.6-4c-7.6 10-1.9 23.4 9.1 26 .5.1 2.4.5 4.2.5 2.4 0 4.3-.7 4.3-.7V3.8c0-.1-15.1 10.4-15.2 10.5M59.1 28.4V10.8h6.6v32.4h-.2L46.7 24.9v17.7h-6.6V10.2h.2zM93.7 16.8h-14v6.8h12.1v5.7H79.7v7.2H94v6.1H73.1V10.8h20.6zM23.9 53.6l-3.2 3.7c-1.3-1.5-3.2-2.7-5.7-2.7-4.4 0-7.4 3.3-7.4 8s2.9 8.1 7.4 8.1c2.6 0 4.5-1.2 5.8-2.8l3.2 3.7c-2.4 2.7-5.3 3.7-9 3.7-7.4.1-12.6-5.3-12.6-12.6C2.4 55.5 7.6 50 14.9 50c4 0 6.7 1.2 9 3.6M34.4 70.4h10.5v4.5H29.3V50.4h5.1zM68.9 66.1c0 5.6-3.4 9.3-9.8 9.3s-9.8-3.7-9.8-9.3V50.4h5.1v15.4c0 2.9 1.6 4.9 4.7 4.9 3 0 4.7-2 4.7-4.9V50.4h5.1zM91.8 57c0 2.4-1.2 3.9-2.4 4.7 2.5.9 4.4 2.6 4.4 6 0 4.6-3.6 7.1-8.2 7.1H74.4V50.4h9.5c4.9 0 7.9 2.5 7.9 6.6m-12.3-2v5.4h3.9c1.9 0 3.2-1.1 3.2-2.7 0-1.7-1.2-2.7-3.3-2.7zm0 9.4v5.8H85c2.1 0 3.6-1 3.6-2.9s-1.4-2.9-3.8-2.9z"
      className="st3"
    />
    <path
      d="M119 5.1v69"
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeMiterlimit: 10,
      }}
    />
  </svg>
);
export default SvgOneClubMastercardFull;
